import { Component } from '@angular/core';
/**
 * Scattergraph icon component declaration, responsible for displaying the icon for scattergraph in vis-type selection
 */
@Component({
  selector: 'mav-scatter-graph-icon',
  templateUrl: './scatter-graph-icon.component.html',
  styleUrls: ['./scatter-graph-icon.component.scss']
})
export class ScatterGraphIconComponent { }
